import React from 'react';
import classNames from 'classnames';
import styled, { css } from 'styled-components';
import _ from 'lodash';
import { colors } from '../../style';
import { SpacingProps } from '../box';
import {
  CssUnitsAsResponsiveObject,
  getCssRuleWithResponsiveCalculation,
} from '../../utils/get-css-rule-with-responsive-calc';
import { mapSpacingPropsToValues, withSpacing } from '../../utils/with-spacing';
import { variants } from './style';

interface HrProps extends SpacingProps {
  className?: string;
  style?: React.CSSProperties;
  expand?: CssUnitsAsResponsiveObject<'sm' | 'md' | 'lg' | 'xs'>;
  expandLeft?: CssUnitsAsResponsiveObject<'sm' | 'md' | 'lg'>;
  expandRight?: CssUnitsAsResponsiveObject<'sm' | 'md' | 'lg'>;
  block?: boolean;
  variant?: keyof typeof variants;
  height?: number;
}

export const HrComponent = ({ className, style }: HrProps) => (
  <hr className={classNames('box-hr', className)} style={style} />
);

const Hr = styled(HrComponent)<HrProps>`
  border: 0;
  border-top: ${props => `${props.height || 1}px solid ${colors.gray100}`};
  margin-top: 16px;
  margin-bottom: 16px;
  margin-right: 0;
  margin-left: 0;
  ${withSpacing};
  border-color: ${props => {
    const variant = variants[props.variant || 'gray300'];
    return typeof variant === 'function' ? variant(props) : variant;
  }};

  ${props => {
    return (
      props.expandRight &&
      css`
        ${getCssRuleWithResponsiveCalculation({
          property: 'margin-right',
          value:
            typeof props.expandRight === 'string'
              ? `-${mapSpacingPropsToValues(props.expandRight)}`
              : _.mapValues(mapSpacingPropsToValues(props.expandRight), (pixels: string) => `-${pixels}`),
        })};
      `
    );
  }}
  ${props => {
    return (
      props.expandLeft &&
      css`
        ${getCssRuleWithResponsiveCalculation({
          property: 'margin-left',
          value:
            typeof props.expandLeft === 'string'
              ? `-${mapSpacingPropsToValues(props.expandLeft)}`
              : _.mapValues(mapSpacingPropsToValues(props.expandLeft), (pixels: string) => `-${pixels}`),
        })};
      `
    );
  }}
  ${props => {
    return (
      props.expand &&
      css`
        ${getCssRuleWithResponsiveCalculation({
          property: 'margin-left',
          value:
            typeof props.expand === 'string'
              ? `-${mapSpacingPropsToValues(props.expand)}`
              : _.mapValues(mapSpacingPropsToValues(props.expand), (pixels: string) => `-${pixels}`),
        })};
        ${getCssRuleWithResponsiveCalculation({
          property: 'margin-right',
          value:
            typeof props.expand === 'string'
              ? `-${mapSpacingPropsToValues(props.expand)}`
              : _.mapValues(mapSpacingPropsToValues(props.expand), (pixels: string) => `-${pixels}`),
        })};
      `
    );
  }}

  ${props =>
    props.block &&
    css`
      width: 100%;
    `}
`;

export default Hr;
